import { PricingPlan } from '../../consts/enums';

export const PLAN_NAMES: Partial<Record<PricingPlan, string>> = {
  [PricingPlan.Trial]: 'Trial',
  [PricingPlan.Tier1B]: 'Custom (credits-based)',
  [PricingPlan.Scale]: 'Custom (position-based)',
};
